import { produce } from 'immer';

import { RestoreInternalBanners } from '../../../actions/bannersEdit/internal/restoreInternalBanners';
import { BannerId } from '../../../typings/banners';
import { EditInternalBannersState } from '../../../typings/internalBannersEditState';

export function restoreInternalBanners(
    state: EditInternalBannersState,
    action: RestoreInternalBanners
): EditInternalBannersState {
    return produce(state, draft => {
        action.bannersIds.forEach((bannerId: BannerId) => {
            const groupId = draft.banners[bannerId].group.id;

            draft.banners[bannerId].markedForDeletion = false;

            draft.groupBannersList[groupId].bannersTotal += 1;
        });
    });
}
